import React from "react";
import { Container, Button } from "shards-react";

const PMCaresFund = () => (
  <Container fluid className="main-content-container px-4 pb-4">
    <div className="error">
      <div className="error__content">
        <h2>STAY HOME, STAY SAFE</h2>
        <h3>PM CARES FUND</h3>
        <p>Kindly contribute to PM Cares fund to help our nation.</p>
        <a href="https://pib.gov.in/PressReleseDetailm.aspx?PRID=1608851" target="_blank"><Button pill>Donate Now</Button></a>
      </div>
    </div>
  </Container>
);

export default PMCaresFund;
